import { render, staticRenderFns } from "./ProviderView.vue?vue&type=template&id=f16a7d6e&scoped=true"
import script from "./ProviderView.vue?vue&type=script&lang=ts"
export * from "./ProviderView.vue?vue&type=script&lang=ts"
import style0 from "./ProviderView.vue?vue&type=style&index=0&id=f16a7d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16a7d6e",
  null
  
)

export default component.exports